import { type PhotoBankStore } from '../../stores/photoBankStore/PhotoBankStore'

export function getUploadStatusProps(
  photoBankStore: PhotoBankStore,
  photoUids: string[]
) {
  const uploadedUids = photoUids.filter((uid) =>
    photoBankStore.didPhotoUpload(uid)
  )
  return {
    'All Photos Uploaded': photoUids.length === uploadedUids.length,
    'Uploaded Photos Count': uploadedUids.length,
    'Total Photos Count': photoUids.length,
  }
}
